import { useStore } from '@stores';
import { useEffect } from 'react';

export const usePublicStatement = (id: string | undefined) => {
  const { statementStore } = useStore();
  const { statement, loading } = statementStore;

  useEffect(() => {
    // Clear any statement left in the shared store (edit/logPayment also write it) so we never flash
    // a previously-loaded statement before this id resolves.
    statementStore.clearStatement();
    if (id) statementStore.getPublicStatement({ id });
    return () => statementStore.clearStatement();
  }, [statementStore, id]);

  return { statement, loading };
};
